class InfoController {
    constructor(
        private message: string, // used in view
        private title: string, // used in view
    ) {}
}

export default angular.module('mpdx.common.modal.info.controller', []).controller('infoController', InfoController)
    .name;
